import React from 'react';
import Select from 'react-select';
export const userTypesList = [
  {
    label:'صاحبین بار',value:'customer'
  },
  {
    label:'رانندگان',value:'driver'
  },
  {
    label:'باربری',value:'freight'
  }
  
];

const SelectUserTypes = React.memo((props) => {
  let { userTypes, isDisabled } = props;
  isDisabled === undefined && (isDisabled = false);

  const handleSelectUserTypes = (option) => {
    props.onChange(option);
  };
  return (
    <Select
      options={userTypesList}
      isMulti={true}
      isSearchable={true}
      placeholder="انتخاب نوع کاربر"
      value={!!userTypes?userTypes:[]}
      onChange={(option) => handleSelectUserTypes(option)}
      noOptionsMessage={() => 'یافت نشد'}
      isDisabled={isDisabled}
    />
  );
});

export default SelectUserTypes;
